import { render, staticRenderFns } from "./ModalItem.vue?vue&type=template&id=093d2005&scoped=true"
import script from "./ModalItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalItem.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093d2005",
  null
  
)

export default component.exports